import { Box, Container, Flex } from '@qga/roo-ui/components';

import ToggleContent from '@shared/v2/components/ToggleContent';
import htmlToReact from '@shared/v2/utils/htmlToReact';

import Disclosure from '@/components/Disclosure';
// Legacy
import Heading from '@/components/Heading';
import LinkButton from '@/components/LinkButton/LinkButton';
import useProcuredOffer from '@/components/PackagePage/hooks/useProcuredOffer';
import Text from '@/components/Text';
import usePropertyContent from '@/hooks/usePropertyContent';
import Map from '@/v2/components/pages/PackageViewV2/components/PackageOverview/components/HotelLocation/components/Map/Map';
import Amenities from './components/Amenities';

const AboutHotel = () => {
  const propertyContent = usePropertyContent();
  const procuredOffer = useProcuredOffer();

  return (
    <Container>
      <Disclosure headerTitle="About this hotel" expand variant="large">
        <Flex flexDirection="column" width={[null, null, '75%']} gap={'8'}>
          <Box>
            {procuredOffer ? (
              <>
                <Heading.h5
                  marginBottom={['6', '8']}
                  fontSize={['16px', null, '20px']}
                  fontWeight="700"
                >
                  {propertyContent.name}
                </Heading.h5>
                {propertyContent.tagline && (
                  <Heading.h6
                    marginBottom={['6', '8']}
                    fontSize={['14px', null, '18px']}
                    lineHeight={['18px', null, '22px']}
                    fontWeight="700"
                  >
                    {propertyContent.tagline}
                  </Heading.h6>
                )}
                <Text lineHeight={['28px', null, '24px']}>
                  {htmlToReact(propertyContent.description, {
                    addParagraphs: true,
                  })}
                </Text>
              </>
            ) : (
              <Heading.h5>{propertyContent.name}</Heading.h5>
            )}
          </Box>

          <Box>
            <Heading.h5 marginBottom="4">Getting there</Heading.h5>
            <Flex mb="2">
              <Box width="154px">
                <Text fontWeight="bold">Check-in time</Text>
              </Box>
              <Text>{`From ${propertyContent.checkInAfter}`}</Text>
            </Flex>
            <Flex mb="2">
              <Box width="154px">
                <Text fontWeight="bold">Check-out time</Text>
              </Box>
              <Text>{`Before ${propertyContent.checkOutBefore}`}</Text>
            </Flex>
            <Flex>
              <Box width="154px">
                <Text fontWeight="bold">Hotel address</Text>
              </Box>
              <Flex
                flexDirection={['column', 'row']}
                justifyContent="start"
                flex="1"
                alignItems="start"
              >
                <Text>{propertyContent.address}</Text>
                <ToggleContent
                  toggle={(show) => (
                    <LinkButton
                      onClick={show}
                      noPadding
                      ml={[0, 3]}
                      mt={[1, 0]}
                    >
                      <Text bold link>
                        View map
                      </Text>
                    </LinkButton>
                  )}
                  // @ts-ignore
                  content={(hide) => <Map onClose={hide} />}
                />
              </Flex>
            </Flex>
          </Box>

          <Box>
            <Heading.h5 marginBottom={['4', '6']}>Amenities</Heading.h5>
            <Box>
              <Amenities facilities={propertyContent.facilities} />
            </Box>
          </Box>
        </Flex>
      </Disclosure>
    </Container>
  );
};

export default AboutHotel;
